export const GENDER_OPTIONS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'other', label: 'Other' },
];

export const NAME_MAX_LENGTH = 100;
export const PHONE_LENGTH = 10;

export const AADHAAR_LENGTH = 12;

/** One message for both the length cap and the pattern - they describe the same rule. */
export const AADHAAR_MESSAGE = 'Aadhaar number must be 12 digits and cannot start with 0 or 1';
